import type {
    GetCommerceCustomerActionsRequest,
    GetCommerceCustomerActionsResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const getCommerceCustomerActionsOperation = defineCommerceOperation<
    GetCommerceCustomerActionsRequest,
    GetCommerceCustomerActionsResponse
>("commerce.customer.actions.get");
